<template>
 <!--  <div> -->
    <!-- Sidebar -->
    <ul class="navbar-nav bg-gray sidebar sidebar-dark accordion over-content" id="accordionSidebar">
      <Snowf v-if="current_month == 11"
        :amount="50"
        :size="5"
        :speed="1.5"
        :wind="0"
        :opacity="0.8"
        :swing="1"
        :image="null"
        :zIndex="null"
        :resize="true"
        color="#fff"
      />

      <!-- Sidebar - Brand -->
      <router-link class="sidebar-brand-auto-height d-flex align-items-center justify-content-center" style="z-index:1" to="/">
        <img class="img-fluid" src="@/assets/smile_logo.png">
      </router-link>

      <!-- Divider -->
      <hr class="sidebar-divider my-2">

      <!-- Nav Item - Recent -->
      <li v-if="checkRole('UPAC')" class="nav-item" @click="sideBarTrigger" v-bind:class="{active: this.current_page == 'Recent'}">
        <router-link class="nav-link" to="/">
          <i class="fas fa-fw fa-home"></i>
          <span>{{ $t('more_recent') }}</span>
        </router-link>
      </li>

      <!-- Nav Item - Historical -->
      <li v-if="checkRole('UPAC')" class="nav-item" @click="sideBarTrigger" v-bind:class="{active: this.current_page == 'Historical'}">
        <router-link class="nav-link" to="/historical">
          <i class="fas fa-fw fa-calendar"></i>
          <span>{{ $t('historical') }}</span>
        </router-link>
      </li>

      <!-- Nav Item - Comparison -->
      <li v-if="checkRole('UPAC')" class="nav-item" @click="sideBarTrigger" v-bind:class="{active: this.current_page == 'Comparison'}">
        <router-link class="nav-link" to="/comparison">
          <i class="fas fa-fw fa-chart-bar"></i>
          <span>{{ $t('comparison') }}</span>
        </router-link>
      </li>

      <!-- Nav Item - Appliances -->
      <li v-if="checkRole('Appliances')" class="nav-item" @click="sideBarTrigger" v-bind:class="{active: this.current_page == 'Appliances'}">
        <router-link class="nav-link" to="/appliances">
          <i class="fas fa-fw fa-plug"></i>
          <span>{{ $t('appliances') }}</span>
        </router-link>
      </li>

      <!-- Nav Item - Substations -->
      <li v-if="checkRole('Substations')" class="nav-item" @click="sideBarTrigger" v-bind:class="{active: this.current_page == 'Substations'}">
        <router-link class="nav-link" to="/transformation-stations">
          <i class="fas fa-fw fa-bolt"></i>
          <span>{{ $t('transformation_stations') }} </span> 
          <!-- <h6 class="d-inline"><span class="badge badge-info">{{ $t("new") }}!</span></h6> -->
        </router-link>
      </li>

      <!-- Nav Item - EV -->
      <li v-if="checkRole('EV')" class="nav-item" @click="sideBarTrigger" v-bind:class="{active: this.current_page == 'EV'}">
        <router-link class="nav-link" to="/ev">
          <i class="fas fa-fw fa-car"></i>
          <span>{{ $t('electric_vehicles') }}</span>
        </router-link>
      </li>

      <!-- Nav Item - Samples -->
      <li v-if="user_is_admin" class="nav-item" @click="sideBarTrigger" v-bind:class="{active: this.current_page == 'Samples'}">
        <router-link class="nav-link" to="/samples">
          <i class="fas fa-fw fa-database"></i>
          <span>samples</span>
        </router-link>
      </li>

      <!-- Divider -->
      <hr class="sidebar-divider my-2">

      <!-- Sidebar Toggler (Sidebar) -->
      <div class="text-center d-md-none d-xl-block" style="z-index: 2">
        <button class="rounded-circle border-0" id="sidebarToggle"></button>
      </div>

    </ul>
    <!-- End of Sidebar -->
  <!-- </div> -->
</template>

<script>
import Snowf from 'vue-snowf'

const toggleSideBarFunction = function(o){
  $("body").toggleClass("sidebar-toggled"); 
  $(".sidebar").toggleClass("toggled"); 
  $(".sidebar").hasClass("toggled") && $(".sidebar .collapse").collapse("hide")
}

export default {
  name: 'SideBar',
  components: {
    Snowf,
  },
  props: {
    title: String
  },
  mounted: function(){
    $("#sidebarToggle").on("click", function(o) { toggleSideBarFunction(o) })
    if(window.innerWidth >= 768 && window.innerWidth < 1200) $("#sidebarToggle").trigger("click")
  },
  methods: {
    toggleSideBar: function(o){
      toggleSideBarFunction(o)
    },
    sideBarTrigger: function(){
      if(window.innerWidth <= 767) $("#sidebarToggleTop").trigger("click")
    },
    checkRole: function(role){
      if (this.user_roles.indexOf('SuperAdmin') >= 0) return true
      if (this.user_roles.indexOf(role) >= 0) return true
    }
  },
  computed:{
    user_is_admin: function(){
      return this.$store.getters.user_isAdmin
    },
    user_roles: function(){
      return this.$store.getters.user_roles
    },
    current_page: function(){
      return this.$route.name
    },
    current_month: function () {
      return (new Date()).getMonth()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import "https://fonts.googleapis.com/css?family=Raleway:400,700|Roboto+Condensed:300,400,700";

li.nav-item.active {
  background: #595959;
  color: white !important;
  border-radius: 0px;
  border-left: 15px solid #33cc99 !important;
  border-top: none;
}

.bg-gray {
  background-color: #333333;
}

.sidebar-brand-auto-height {
  height:auto;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 800;
  padding: 1.5rem 1rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: .05rem;
}

ul {
  font-family: 'Roboto Condensed', sans-serif;
}

.over-content{
  position: absolute;
  z-index: 5!important; 
  height: 100%; 
} 

@media only screen and (min-width : 768px) {
  .over-content{
    position: relative;
    height: auto;
    z-index: 0;
  }
}
</style>